import { QUICK_COMMERCE_APIS } from "@/api_framework/api_config";
import {
  IQuickCommercePincodeOnboardPostBody,
  IQuickCommercePincodeOnboardResponse,
} from "@/api_framework/api_modals/QuickCommerce";
import { useQuickCommerce } from "@/app/hooks/useQuickCommerce";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useQuickCommercePincodeOnboardAPI = () => {
  const [newPincodeId, setNewPincodeId] = useState<string>("");
  const quickCommerce = useQuickCommerce();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (pincodeData: IQuickCommercePincodeOnboardPostBody) => {
      try {
        const accessToken = localStorage.getItem(quickCommerce.localStorage.ACCESS_TOKEN.key);
        if (!pincodeData) {
          return;
        }
        await axios
          .post(`${QUICK_COMMERCE_APIS?.PINCODE_ONBOARD?.baseURL}` ?? "", JSON.stringify(pincodeData), {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IQuickCommercePincodeOnboardResponse>) => {
            if (res.data.status === true) {
              setNewPincodeId(res?.data?.data?.city_id);
              toast.success(`Pincode ${pincodeData?.pincode} , onboarded successfully. `);
            } else {
              // console.log("not created");
              toast.error("Cannot create pincode.");
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        // Handle errors
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("Pincode already exists");
            // toast.error("Error at server while creating city.");
          }
          // if (axiosError.response?.status === 400) {
          //   toast.error(axiosError.message);
          // }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
          // if (axiosError.response?.status === 400) {
          //   toast.error(axiosError.message);
          // }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, quickCommerce],
  );

  return { newPincodeId, execute };
};
